/** Window events the MMEC chrome listens for. Kept here so the top bar and shell need not import each other. */

/** Open the command palette. Dispatched by the top bar's search button; handled by MMECShell. */
export const OPEN_PALETTE_EVENT = 'mmec-open-command-palette';
